import {Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
    selector: 'sticky-search-header',
    templateUrl: './sticky-search-header.component.html',
    styleUrls: ['./sticky-search-header.component.css']
})
export class StickySearchHeaderComponent {

    @Output()
    onChange = new EventEmitter<string>();

    @Output()
    onClear = new EventEmitter<void>();

    public filterValue = '';


    onInputChange(value: string): void {
        this.onChange.emit(value);
    }

    onClearedSelected(): void {
        this.filterValue = ''
        this.onClear.emit();
    }
}
